export class LocalStorageKeys {
    static readonly OAUTH_TOKEN = 'oauth_token';
    static readonly PREFERRED_LANGUAGE = 'preferred_language';
    static readonly USER_DETAILS = 'user_details';
    static readonly LAST_BIKE_MAP_EXTENT = "last_bike_map_extent";
    static readonly LIVE_MAP_ZOOM_LEVEL = "live_map_zoom_level";
    static readonly LAST_DOCKING_STATION_MAP_EXTENT = "last_docking_station_map_extent";
    static readonly SELECTED_TRACK_MAP = "selected_track_map";
    static readonly MENU_ITEMS = "menu_items";
    static readonly PREFERRED_TIMEZONE = 'preferred_timezone';
    static readonly SELECTED_AREAS = 'selected_areas';
    static readonly DASHBOARD_TOKEN = 'dashboard_token';
}